<template>
  <div>
    <div class="opc-plan__bought-license" v-if="displayCount">
      <span>{{ $t('billing.prorated.cur_users', [displayCount, unit] ) }}</span>
    </div>
    <slot v-else></slot>
  </div>
</template>
  
<script>
import { getPlanUnitWithQuantity } from '@/common/product-unit';
import mx from './mx.vue';
export default {
  props: {
    value: Number
  },
  mixins: [mx],
  computed: {
    displayCount(){
      if(this.mx_boughtPlan.category !== this.mx_cartPlan.category) return "";
      return `${this.mx_boughtPlan.cartInfo?.selected_number??''}`;
    },
    unit(){
      return getPlanUnitWithQuantity(this.mx_boughtPlan?.unit);
    }
  },
};
</script>
  
<style lang="scss" scoped>
.opc-plan__bought-license {
  font-family: Almaden Sans;
  font-size: 14px;
  font-weight: 400;
  line-height: 16.8px;
  padding: 8px 0;
  text-align: left;
  color: #666487;
}
</style>
